'use strict';

export default class ContactezNous {
  constructor(options) {

    console.log('ContactezNous component');

    const defaults = {
        toggleFormAction: '.toggle--form',
        form: '#block-domusvi-contact-forms-domusvi-contact-form-page-form .contact-page-iframe'
    };

    this.options = Object.assign({}, defaults, options);

    //auto init
    this._toggleFormAction();
    this._messagesContactezNous();

  }

  _toggleFormAction() {
    $(this.options.toggleFormAction).on('click', function(evt) {
        evt.preventDefault();

        $(this.options.form).slideToggle();
    }.bind(this));
  }

  _messagesContactezNous () {

    if( $('.messages').html()){
      $(this.options.form).slideToggle();
    }

  }

}
